import React, { useEffect, useState } from 'react'
import style from './AddCategory.module.scss'
import Back from '../../../../shared/components/backButton/backButton'
import ImageUpload from '../../../../shared/components/imageUpload/imageUpload'
import Input from '../../../../shared/components/inputFields/input'
import Button from '../../../../shared/components/button/button'
import buttonStyle from '../../../../shared/components/button/button.module.scss'
import { Status } from '../../../../shared/globalConstants/constants'
import useAxiosInstance from '../../../../hooks/useAxiosInstance'
import { useDispatch, useSelector } from 'react-redux'
import AWS from "aws-sdk"
import { isLoading } from '../../../../redux/progressLoader/progressLoader.actions'
import Toaster from '../../../../components/Global/Toaster/Toaster.component'
import { CATEGORY } from '../category/categoryManagementConstant'
import { addAdminCategoryCreate } from '../../../../redux/FengShui/adminCategory/adminCategory.actions'
import { generateUUID } from '../../../../hooks/uniqueIdGenerator'
import { languageState } from '../../../../redux/AurLaVieAdmin/languages/getLanguages.selector'
import { useNavigate } from 'react-router-dom'

const AddCategory = () => {
  const axiosInstance = useAxiosInstance()
  const dispatch = useDispatch()
  const [toastList, setToastList] = useState([])
  const [userDetails, setUserDetails] = useState()
  const [formData, setFormData] = useState({})
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false)
  const state = useSelector(state => state)
  const [mainImage, setMainImage] = useState("")
  const navigate = useNavigate()
  const [removeImage, setRemoveImage] = useState(false)

  useEffect(() => {
    if(formData['Category Name'] !== ''
        && formData['Category Name'] !== undefined
        && formData["Category Sub Heading"] !== ''
        && formData["Category Sub Heading"] !== undefined
        && formData["status"] !== ''
        && formData["status"] !== undefined) {
      setIsSubmitDisabled(false)
    } else {
      setIsSubmitDisabled(true)
    }
  },[formData])

  // if(!state?.getLanguages?.languageId) return <div>hello</div>


  const inputFields = [
    {
      type: "text",
      name: "Category Name",
      label: 'Category Name',
      required: false,
      width: '100%'
    },
    {
      type: "text",
      name: "Category Sub Heading",
      label: 'Category Sub Heading',
      required: false,
      width: '100%'
    },
    {
      type: "radio",
      name: "status",
      label: 'Status',
      options: Status,
      width: '50%'
    },
  ]

  const handleInputChange = (fieldName, fieldValue) => {
    setFormData({ ...formData, [fieldName]: fieldValue })
  }

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  })

  const myBucket = new AWS.S3({
    params: { Bucket: process.env.REACT_APP_AWS_BUCKET_NAME },
    region: process.env.REACT_APP_AWS_REGION,
  })



  const handleAdd = (imageUrl) => {
    const userId = state?.user?.data?._id

    const data = {
      "appId": localStorage.getItem("appId"),
      "languageId": state?.getLanguages?.languageId,
      // "parentId": null,
      "categoryName": formData['Category Name'],
      "subHeading": formData['Category Sub Heading'],
      "imgPath": (imageUrl && !imageUrl?.includes('undefined')) ? imageUrl : formData.bookImage,
      "status": formData?.status,
      "created_by": userId,
      "modified_by": userId,
    }
    dispatch(addAdminCategoryCreate(axiosInstance, data, {}))
      .then((res) => {
        setToastList([
          {
            id: 0,
            // title: "Category Added Successfully",
            title: res.message,
            icon: "success",
          },
        ])
        setRemoveImage(true)
        setFormData({})
        setTimeout(() => {
          navigate(-1)
        }, 1500)
      })
      .catch((err) => {
        setToastList([
          {
            id: 0,
            // title: "Adding Category Failed",
            title: err?.response?.data?.message,
            icon: "error",
          },
        ])
      })
  }

  const uploadToS3 = async (file, name) => {
    const id = generateUUID();
    const fileKey = `tip-main-${id}.${file?.type.split("/")[1]}`;
    const params = {
      Body: file,
      Bucket: process.env.REACT_APP_AWS_BUCKET_NAME,
      Key: fileKey,
    }
    try {
      dispatch(isLoading(true))
      const upload = await myBucket.upload(params).promise()
      if (upload) {
        dispatch(isLoading(false))
        handleAdd(upload.Location)
      }
    } catch (error) {
      setToastList([
        {
          id: 0,
          // title: "Error",
          title: "Error while uploading the Category image.",
          icon: "error",
        },
      ]);
      dispatch(isLoading(false));
    }
  }

  const onCreate = (e) => {
    e.preventDefault()
    if (mainImage) {
      uploadToS3(mainImage, mainImage.name)
    } else {
      handleAdd()
    }
  }


  const handleFile = (url) => {
    if (url) {
      setMainImage(url)
    }
  }

  return (
    <div className={style.container}>
      <div className={style.wrapper}>
        <div className={style.back}>
          <Back title={CATEGORY.ADD_CATEGORY.BACK.TITLE} description={CATEGORY.ADD_CATEGORY.BACK.DESCRIPTION} />
        </div>
        <div className={style.form_container} >
          <div className={style.upload}>
            <ImageUpload handleFile={handleFile} removeImage={removeImage} title={CATEGORY.ADD_CATEGORY.UPLOAD.TITLE} previewImage={userDetails?.profilePic} />
          </div>
          <form onSubmit={onCreate}>
            <div className={style.form_container}>
              {inputFields.map((inputField, index) => (
                <div key={index} className={style.input_field} style={{ width: inputField.width }}>
                  <Input
                    type={inputField.type}
                    name={inputField.name}
                    label={inputField.label}
                    value={formData[inputField.name]}
                    placeholder={inputField.placeholder}
                    options={inputField.options}
                    required={inputField.required}
                    onChange={(value) => handleInputChange(inputField.name, value)}
                    handleInputBlur={() => { }}
                  />
                  {/* <div className={style.error}>{formErrors[inputField.name]}</div> */}
                </div>
              ))}
              <div className={style.action_button}>
                <Button disabled={isSubmitDisabled} text={CATEGORY.ADD_CATEGORY.BUTTONS.TITLE} buttonType={isSubmitDisabled ? `${buttonStyle.button_disabled}` : `${buttonStyle.button_primary}`} />
              </div>
            </div>
          </form>
        </div>
      </div>
      <Toaster
        toastList={toastList}
        position={"top-right"}
        autoDelete={true}
        autoDeleteTime={2500}
      />
    </div>
  )
}

export default AddCategory